import { DateTemplate } from './DateTemplate';
import { TextTemplate } from './TextTemplate';

// Template functions for grid columns
export const dateTemplate = (props: { addDate: string }) => (
  <DateTemplate dateString={props.addDate} />
);

export const textTemplate = (props: { text: string }) => (
  <TextTemplate text={props.text} />
);
